window.Drupal.behaviors.clubDatalayer = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", (event) => {
      const bodyPageMoments = document.querySelector('body.page-moments');
      const iframeGame = document.querySelector("#iframe--play-club-embed");
      if (bodyPageMoments == false) {
        let btnData = document.querySelectorAll('.club__highlighted--caption .data-event');
        if (btnData) {
          for (let index = 0; index < btnData.length; index++) {
            const element = btnData[index];
            element.addEventListener('click', function (e) {
              dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'Club Colombia Blog',
                'eventAction': 'Ver más',
                'eventLabel': this.parentElement.children[0].innerHTML,
              });
            });
          }
        }

        let relatedCommerceLink = document.querySelector('.related-commerce .related-commerce__right a');
        if (relatedCommerceLink) {
          relatedCommerceLink.addEventListener('click', function (e) {
            dataLayer.push({
              'event': 'trackEvent',
              'eventCategory': 'Doble Malta 2.0',
              'eventAction': 'Clic TaDa',
              'eventLabel': 'Conocer mas',
            });
          });
        }

        let shareSocialNetworksPopup = document.querySelectorAll('#shareSocialNetworks .modal-body a');
        if (shareSocialNetworksPopup) {
          let heroVideoLabel = document.querySelector('.hero-video .field__label');
          for (let index = 0; index < shareSocialNetworksPopup.length; index++) {
            const element = shareSocialNetworksPopup[index];
            element.addEventListener('click', function (e) {
              dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'Doble Malta 2.0',
                'eventAction': `Compartir RRSS / ${heroVideoLabel.innerHTML}`,
                'eventLabel': element.children[0].alt,
              });
            });
          }
        }

        let landingfieldSlide = document.querySelector('.block-field-blocknodeproduct-landingfield-slide');
          if (landingfieldSlide) {
            let landingfieldSlideLink = landingfieldSlide.querySelector('.field--name-field-link a');
            let landingfieldSlideTitle = landingfieldSlide.querySelector('.club__hero-slider--title');
            landingfieldSlideLink.addEventListener('click', function (e) {
              dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'Doble Malta 2.0',
                'eventAction': 'Play',
                'eventLabel': landingfieldSlideTitle.innerHTML,
              });
            });
          }  
      }
      if (iframeGame) {
        const toGameDatalayer = () => {
          dataLayer.push({
            event: "GAEvent",
            event_category: "Content",
            event_action: "Button",
            event_label: "Play Again",
            interaction: "true",
            component_name: "Botón_VolverAJugar",
            element_text: "Volver a Jugar",
            campaign_description: "Meals 3 Club Colombia",
          });
        };

        const endGameDatalayer = (score) => {
          dataLayer.push({
            event: "GAEvent",
            event_category: "Game",
            event_action: "Finish",
            event_label: score,
            interaction: "true",
            component_name: "Popup_FinalizoJuego",
            element_text: "Fin del Juego",
            campaign_description: "Meals 3 Club Colombia",
          });
        };

        const playGameDatalayer = () => {
          dataLayer.push({
            event: "GAEvent",
            event_category: "Game",
            event_action: "Start",
            event_label: "Play",
            interaction: "true",
            component_nam: "Botón_Jugar",
            element_text: "Jugar",
            campaign_description: "Meals 3 Club Colombia",
          });
        };

        parent.toGameDatalayer = toGameDatalayer;
        parent.endGameDatalayer = endGameDatalayer;
        parent.playGameDatalayer = playGameDatalayer;
      }
    });
  }
};

